import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { makeStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import Card from '@mui/material/Card';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import Avatar from '@mui/material/Avatar';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import {TimeFromNow} from "../TimeFromNow";
import {httpClient} from "../../core/HttpClient";

const useStyles = makeStyles((theme) => ({
    root: {},
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none'
    },
    list: {
        paddingTop: 0
    },
    listSection: {
        backgroundColor: 'inherit',
    },
    ul: {
        backgroundColor: 'inherit',
        padding: 0,
    },
}));

export default function OrderListView({mode, cid}) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    console.log('OrderListView');

    useEffect(() => {
        console.log('[OrderListView]');
        const url = process.env.REACT_APP_API_BASE_URL + `/orders/list?mode=${mode}`;
        httpClient.get(url)
            .then(res => {
                if (res.data) {
                    setOrders(res.data);
                }

                setLoading(false);
            });

        // if (cid) {
        //     let key = 'accounts/'+ cid + '/orders/count';
        //     firebase.database().ref(key).on('value', function(data) {
        //         httpClient.get(url)
        //             .then(res => {
        //                 if(res.data){
        //                     setOrders(res.data)
        //                 }
        //                 setLoading(false);
        //             });
        //     });
        // }

    }, [mode]);





    return (
        <div className={classes.root}>
            {loading &&
            <Box display="flex" justifyContent="center" mt={4} mb={4}>
                <CircularProgress size={20}/>
            </Box>
            }
            {!loading &&
            <Card elevation={0}>
                {orders.length === 0 &&
                <Box display="flex" justifyContent="center" p={2} m={2}>
                    <Typography>
                        {t('common.notFound')}
                    </Typography>
                </Box>
                }
                {orders.length > 0 &&
                <List className="SortableList">
                    {orders.map((value, index) => (
                        <ListItem key={`item-${value._id}`} divider={index !== orders.length - 1 ? true : false} button
                                  component={Link} to={`/orders/action/${value.uid}`}>
                            {value.customer &&
                            <ListItemAvatar>
                                <Avatar
                                    src={`${process.env.REACT_APP_CDN_BASE_URL}/public/customer/${value.customer._id}`}></Avatar>
                            </ListItemAvatar>
                            }
                            <ListItemText>
                                <div>
                                    <Box display="flex" justifyContent="space-between">
                                        <Typography noWrap={true}>
                                            <span>
                                                {value.customer && value.customer.displayName}
                                            </span>
                                        </Typography>
                                        <div>
                                            <span style={{color: '#7d7d7d', fontSize: '1rem'}}>
                                                <TimeFromNow value={value.timeLine.orders}/>
                                            </span>
                                        </div>
                                    </Box>
                                    <Box display="flex" justifyContent="space-between">
                                        <Typography noWrap={true}>
                                        <span style={{color: '#7d7d7d', fontSize: '1rem'}}>
                                            {value.orderNo}
                                        </span>
                                        </Typography>
                                        <div>
                                            <span>{t(`order.${value.status}`)}</span>
                                        </div>
                                    </Box>
                                </div>
                            </ListItemText>
                            <Badge color="primary" variant="dot" invisible={value.status !== 'pending'}
                                   style={{top: '-28px', right: '-8px'}}></Badge>
                        </ListItem>
                    ))}
                </List>
                }
            </Card>
            }
        </div>
    )
}